.root {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.item {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
}

.item-is-open {
  border-color: var(--color-primary);
  // An open item must let its body's popovers (e.g. a Select's option list)
  // extend past the item edge — the base `overflow: hidden` (kept for corner
  // clipping on closed items) would otherwise clip the dropdown inside the fold.
  // Safe because the body is conditionally mounted, not height-animated.
  overflow: visible;
}

.header {
  align-items: center;
  background: transparent;
  border: none;
  color: var(--color-text);
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 12px;
  justify-content: space-between;
  padding: 14px 16px;
  text-align: left;
  width: 100%;
}

.header:hover:not(.header-is-disabled) {
  background: var(--color-background-subtle);
}

.header-is-disabled {
  color: var(--color-text-muted);
  cursor: not-allowed;
}

.header-label {
  flex: 1;
  min-width: 0;
}

.chevron {
  color: var(--color-text-muted);
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.chevron-is-open {
  transform: rotate(180deg);
}

.body {
  border-top: 1px solid var(--color-border);
  padding: 16px;
}
